/**
 * Registry of Mat SVG icons.
 * Color variants with identical geometry share one file; tint comes from CSS by svgIcon name.
 */
export interface ThemeIconRegistration {
    name: string;
    file: string;
}

/** Canonical file per alias group (identical path geometry). */
export const THEME_ICON_FILE_ALIASES: Readonly<Record<string, string>> = {
    'PlusCircle-enabled-white.svg': 'PlusCircle-enabled-primary.svg',
    'PlusCircle-disabled-primary.svg': 'PlusCircle-enabled-primary.svg',
    'checkCircle_disabled.svg': 'checkCircle_enable.svg',
    'ellipse-red.svg': 'ellipse-green.svg',
    'exit-disabled.svg': 'exit.svg',
    'ListPlus-disabled-primary.svg': 'ListPlus-enabled-primary.svg',
    'Trash-disabled.svg': 'Trash-enabled-primary.svg',
    'trash-circle-disabled.svg': 'trash-circle-primary.svg',
    'dot-grey.svg': 'dot-green.svg',
    'dot-red.svg': 'dot-green.svg',
    'dot-yellow.svg': 'dot-green.svg',
};

export function resolveThemeIconFile(fileName: string): string {
    return THEME_ICON_FILE_ALIASES[fileName] ?? fileName;
}
